/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PlaystationNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4ElEQVR4nOWUv2sVQRDHL1FJjBZaJGkM+KuLoJUWEa7xyQu382Nf3Ju5M/KweYVikz/ARyqtJIidhQkhXUiamCKYNijYWQnBH6BgbDTYKRhZTPSyvICRdxDIwjbDMJ+dme93o2g/nA5mOVNa9UajcQhZN5D1A7DOEEmeJPnxMgAbWxdIvgPLU8Ny1XdYAkBXC7AXAO5UGwGy7pw7gKSLRWClMnqkPQCSdz4OpBPb4lZvtxfA8iCIT5YLYH1WdgfLpQKAdKI0ALB82bXbmbOL/lWJTc+3BID2A0sDWcb+2QcA7iyy3AXS139eV0uHQoDXPLDUkPW+dzSwvPQXSZaA5BGiXnPOHd2q24E2VSRZCVTxw5uJSE6GAMT0ZmC+T8gyC6xTwPp2cydfDWW3IiBZ2LYsludAesfa0T5Pd84dbg2QdWR9AlYr3tnGmB7/ESLrm0Ktj5GXV/FfMZxdRkyvIGvTj6rViKrO9XpwHMcHDcswkkwD6bcgbwVAB6NqtdplSG4AyxySfg7G9BNRL4WA32OTh0CyFuS/B9J7iU3P7bhoovqxpJaftvb6CS/RVjIt7sBLFFgeG87iZrPZuSup/oXmF4B0HElfbXaQI8u8oWwkrte7/6vozjAZaGvBPX9+AVk/lO47MLDzAAAAAElFTkSuQmCC)
 */
export const PlaystationNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M23.79 16.92c-.47.59-1.62 1.01-1.62 1.01L13.62 21v-2.26l6.3-2.24c.7-.26.82-.62.24-.81a4.24 4.24 0 0 0-2.35.12l-4.19 1.48v-2.35l.25-.08s1.2-.43 2.9-.62c1.71-.19 3.8.02 5.43.64 1.85.59 2.05 1.45 1.59 2.04Zm-9.35-3.86V7.27c0-.67-.13-1.3-.77-1.48-.48-.15-.79.3-.79.98v14.5l-3.9-1.25V2.74a47 47 0 0 1 5.38 1.48c3.31 1.13 4.43 2.55 4.43 5.74 0 3.1-1.92 4.28-4.35 3.1ZM1.8 18.5c-1.9-.53-2.2-1.64-1.34-2.28.8-.6 2.15-1.04 2.15-1.04l5.6-2v2.28L4.18 16.9c-.71.26-.82.62-.24.81.58.19 1.63.14 2.34-.12l1.93-.7v2.03l-.38.06c-1.94.32-4 .19-6.03-.48Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
